var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuidelines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_004-guia",
    "data-name": "004-guia",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.435,
    height: 69.126,
    viewBox: "0 0 56.435 69.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_612",
    "data-name": "Caminho 612",
    d: "M271.275,149.763a1.35,1.35,0,0,0,1.35-1.35v-5.362a1.35,1.35,0,1,0-2.7,0v5.362A1.35,1.35,0,0,0,271.275,149.763Z",
    transform: "translate(-239.828 -122.57)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_613",
    "data-name": "Caminho 613",
    d: "M271.275,104.238a1.35,1.35,0,0,0,1.35-1.35v-.008a1.35,1.35,0,1,0-1.35,1.358Z",
    transform: "translate(-239.828 -87.826)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_614",
    "data-name": "Caminho 614",
    d: "M102.085,0H50.019A3.022,3.022,0,0,0,47,3.019V62.689a6.444,6.444,0,0,0,6.437,6.436h48.648a1.35,1.35,0,0,0,1.35-1.35V1.35A1.35,1.35,0,0,0,102.085,0ZM49.7,3.019a.323.323,0,0,1,.318-.318H55.7V56.249H53.437a6.4,6.4,0,0,0-3.736,1.2Zm51.034,53.231H80.059a1.35,1.35,0,1,0,0,2.7h20.676v7.476h-47.3a3.738,3.738,0,0,1,0-7.476h14.5a1.35,1.35,0,1,0,0-2.7H58.4V2.7h42.331Z",
    transform: "translate(-47)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_615",
    "data-name": "Caminho 615",
    d: "M197.591,81.971A12.852,12.852,0,1,0,184.74,69.116,12.867,12.867,0,0,0,197.591,81.971Zm0-23a10.152,10.152,0,1,1-10.151,10.15A10.162,10.162,0,0,1,197.591,58.966Z",
    transform: "translate(-166.144 -48.669)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_616",
    "data-name": "Caminho 616",
    d: "M183.532,306.48h20.912a2.256,2.256,0,0,0,2.253-2.253V298.52a2.254,2.254,0,0,0-2.253-2.249H183.532a2.252,2.252,0,0,0-2.25,2.249v5.706A2.254,2.254,0,0,0,183.532,306.48Zm.451-7.509H204v4.808H183.982Z",
    transform: "translate(-163.152 -256.271)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_617",
    "data-name": "Caminho 617",
    d: "M238.307,416.628a1.35,1.35,0,0,0,0,2.7h.008a1.35,1.35,0,1,0-.008-2.7Z",
    transform: "translate(-211.311 -360.379)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidelines);
export default __webpack_public_path__ + "static/media/guidelines.71b65910bb1578bf80efe97c80fb7774.svg";
export { ForwardRef as ReactComponent };